import { useLanguage } from "@tlc/ls2pac/components/Language";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";

export interface HoldStatusData {
  statusLabel: string;
  statusValue: string | number;
  statusClassName: string;
  untilLabel?: string;
  untilValue?: string;
  untilClassName?: string;
  isSuspended: boolean;
}

export const useHoldStatus = () => {
  const { translate } = useLanguage();

  const getHoldStatusData = (
    hold: HostSystemItemView,
  ): HoldStatusData | null => {
    if (hold.suspendUntilDate) {
      return {
        statusLabel: translate("status"),
        statusValue: translate("suspended"),
        statusClassName: "suspended",
        isSuspended: true,
        untilLabel: translate("until"),
        untilValue: hold.suspendUntilDateString,
        untilClassName: "pickupDate",
      };
    }

    switch (hold.status) {
      case "AR":
        return {
          statusLabel: translate("status"),
          statusValue: translate("arrived"),
          statusClassName: "arrived",
          isSuspended: false,
        };
      case "T":
        return {
          statusLabel: translate("status"),
          statusValue: translate("inTransit"),
          statusClassName: "inTransit",
          isSuspended: false,
        };
      case "HR":
        return {
          statusLabel: translate("status"),
          statusValue: translate("holdRequested"),
          statusClassName: "holdRequested",
          isSuspended: false,
        };
      case "HF":
        return {
          statusLabel: translate("status"),
          statusValue: translate("holdOnTheWay"),
          statusClassName: "holdOnTheWay",
          isSuspended: false,
        };
      case "PE":
        return {
          statusLabel: translate("positionInQueue"),
          statusValue: hold.holdQueueLength,
          statusClassName: "queueLength",
          isSuspended: false,
        };
      default:
        return null;
    }
  };

  return { getHoldStatusData };
};
